export default __webpack_public_path__ + "static/footer5_Footer2-c58a520793d5191cb644bc0360629193.png";